import * as fromDatatype from "../../../../models/datatype-library";
import { BaseCriteriaDtoModel } from "./base-dto.model";

enum ARAPObjectType {
    AR_TRADE = "AR_TRADE",
    AP_TRADE = "AP_TRADE",
    AR_OTHER = "AR_OTHER",
    AP_OTHER = "AP_OTHER",
    AR_MERCHANT = "AR_MERCHANT",
    AP_MERCHANT = "AP_MERCHANT",
    AP_EMPLOYEE = "AP_EMPLOYEE"
}

export class EntityCriteriaDTO extends BaseCriteriaDtoModel{
    name?: string;
    txn_type?: string;
    descr?: string;
    contact_key_guid?: string;
    id_no?: string;
    id_no_old?: string;
    id_type?: string;
    phone?: string;
    is_phone_encoded?: boolean;
    ccy_code?: string;
    email?: string;
    ref_1?: string;
    ref_2?: string;
    ref_3?: string;
    ref_4?: string;
    ref_5?: string;
    is_supplier?: boolean;
    is_employee?: boolean;
    is_merchant?: boolean;
    is_customer?: boolean;
    hdr_client_value?: string;
    hdr_client_key?: string;
    hdr_client_source?: string;
    supplier_code?: string;
    employee_code?: string;
    merchant_code?: string;
    customer_code?: string;
    pgw_merchant_code?: string;
    hdr_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    dob?: fromDatatype.TimestampTzDatatypeInterface;
    gender?: string;
    nationality?: string;
    ethnicity?: string;
    tax_category?: string;
    language_code?: string;
    title?: string;
    region_code?: string;
    default_arap_type?: ARAPObjectType;
    spending_limit_status?: string;
    join_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    join_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    resign_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    resign_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    default_org_chart_hdr_guid?: string;
    default_comp_guid?: string;
    default_branch_guid?: string;
    default_location_guid?: string;
    default_division?: string;
    default_department?: string;
    default_team_name?: string;
    default_approval_rank?: number;
    employee_lifecycle_status_code?: string;
    occupation?: string;
    job_title?: string;
    job_industry?: string;
    job_role?: string;
    job_type?: string;
    customer_id?: string;
    tax_reg_number?: string;
    epf_no?: string;
    pricing_scheme_hdr_guid?: string;
    business_nature_code?: string;
    classification?: string;
    fiscal_year_end_month?: number;
    website_url?: string;
    gst_number?: string;
    wht_tax_number?: string;
    alternate_tax_no_1?: string;
    alternate_tax_no_2?: string;
    id_no_expiry_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    id_no_expiry_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    hdr_guids?: string[];
    contact_key_guids?: string[];
    branch_guids?: string[];
    id_nos?: string[];
    phones?: string[];
    encoded_phones?: string[];
    emails?: string[];
    customer_codes?: string[];
    employee_codes?: string[];
    supplier_codes?: string[];
    merchant_codes?: string[];
    pgw_merchant_codes?: string[];
    customer_ids?: string[];
    employee_ids?: string[];
    supplier_ids?: string[];
    merchant_ids?: string[];
    default_sales_agents?: string[];
    default_label_guids?: string[];
    param_code?: string;
    param_name?: string;
    ext_entity_hdr_guid?: string;
    param_type?: string;
    value_string?: string;
    value_numeric?: string;
    value_datetime?: string;
    created_date?: fromDatatype.TimestampTzDatatypeInterface;
    updated_date?: fromDatatype.TimestampTzDatatypeInterface;
    ext_status?: string;
    ext_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    ext_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    ext_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    ext_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    line_txn_type?: string;
    entity_hdr_guid?: string;
    entity_hdr_guids?: string[];
    line_client_key?: string;
    line_client_source?: string;
    line_client_value?: string;
    line_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    line_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    line_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    line_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    link_entity_hdr_guid?: string;
    link_subject_guid?: string;
    link_created_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    link_created_date_from?: fromDatatype.TimestampTzDatatypeInterface;;
    link_updated_date_to?: fromDatatype.TimestampTzDatatypeInterface;
    link_updated_date_from?: fromDatatype.TimestampTzDatatypeInterface;
    payment_condition_in_generate_sql?: boolean;
    payment_hdr_guid?: string;
    payment_account_type?: string;
    payment_account_number?: string;
    payment_account_name?: string;
    payment_bank_name?: string;
    payment_card_no?: string;
    payment_client_source?: string;
    payment_client_key?: string;
    payment_client_value?: string;
    payment_client_keys?: string[];
    fi_item_hdr_guid?: string;
    inv_item_hdr_guid?: string;
    subject_guid?: string;
    entity_line_guid?: string;
    label_hdr_guid?: string;
    entity_code?: string;
}
